import { Check, X } from 'lucide-react';

import { cn } from '@/lib/utils';

import { passwordRequirements } from '../helpers/password-requirements';

interface PasswordStrengthChecklistProps {
  password: string;
  className?: string;
  id?: string;
}


export function PasswordStrengthChecklist({
  password,
  className,
  id = 'password-requirements',
}: PasswordStrengthChecklistProps) {
  return (
    <ul
      id={id}
      className={cn('space-y-2', className)}
      aria-label="Password requirements"
    >
      {passwordRequirements.map(requirement => {
        const isMet = requirement.test(password);
        return (
          <li key={requirement.label} className="flex items-center gap-2">
            <div
              className={cn(
                'flex h-4 w-4 items-center justify-center rounded-full',
                isMet
                  ? 'bg-status-success-solid'
                  : 'border border-border-default bg-surface-inset'
              )}
              aria-hidden="true"
            >
              {isMet ? (
                <Check className="h-3 w-3 text-status-success-solid-foreground" />
              ) : (
                <X className="h-3 w-3 text-content-tertiary" />
              )}
            </div>
            <span
              className={cn(
                'type-body',
                isMet
                  ? 'font-medium text-status-success-foreground'
                  : 'text-content-secondary'
              )}
            >
              {requirement.label}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
